import { Component, OnInit } from '@angular/core';
import { TrustDataService } from '../../services/trust-data-service/trust-data.service';
import { DataQuality } from '../../models/data-quality';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-data-quality-link',
  templateUrl: './data-quality-link.component.html',
  styleUrls: ['./data-quality-link.component.css']
})
export class DataQualityLinkComponent implements OnInit {
  dataQuality: DataQuality;
  loaded = false;

  constructor(private trustDataService: TrustDataService) { }

  ngOnInit() {
    this.trustDataService.getTrustDataQualityContact()
      .pipe(map(response => response.json()))
      .subscribe(response => {
        this.dataQuality = response;
        this.loaded = true;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/data-quality-link/data-quality-link.component.ts